import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
export function Stats() {
  const stats = [{
    label: 'Emprendedores',
    value: '+800 confían',
    icon: Users
  }, {
    label: 'Tomos listos',
    value: '6 completos',
    icon: BookCopy
  }, {
    label: 'Bonos incluidos',
    value: '6 estratégicos',
    icon: Gift
  }, {
    label: 'Calificación',
    value: '4.9/5',
    icon: Star,
    suffix: '⭐'
  }];
  return <section className="py-12 border-y border-white/10 bg-white/5" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <div className="text-center mb-8" data-id="element-260">
          <h2 className="text-2xl font-bold text-white" data-id="element-261">
            📊 Números que hablan
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-262">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-263">
              <div className="w-12 h-12 rounded-full bg-brand-violet/20 flex items-center justify-center mb-4" data-id="element-264">
                <stat.icon className="w-6 h-6 text-brand-violet" data-id="element-265" />
              </div>
              <p className="text-sm text-gray-400 mb-1" data-id="element-266">{stat.label}</p>
              <p className="text-xl font-bold text-white flex items-center gap-1" data-id="element-267">
                {stat.value}{' '}
                {stat.suffix && <span className="text-brand-gold" data-id="element-268">{stat.suffix}</span>}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}